import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";

export const useRejectSession = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ sessionId, reason }: { sessionId: string; reason: string }) => 
      api.post(`onboarding/admin/queue/${sessionId}/reject`, { reason }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.queue() });
    },
    onError: (res: any) => {
      console.error("[From Reject Session]", res);
      handleErrors(res, "mutation");
    },
  });
};
